import React from 'react';

import Paper from '@material-ui/core/Paper';

import TodoList from '../comps/TodoList';

export default function PageGlobalTodo() {
  return (
    <Paper>
      <TodoList group="global"/>
    </Paper>
  )
}



// WEBPACK FOOTER //
// ./src/pages/PageGlobalTodo.js